<i18n locale="en">
{
  "title": "Photo",
  "labels": {
    "upload": "Drag & drop or choose a photo to upload",
    "select": "Select Photo",
    "link": "Click-through URL"
  },
  "placeholders": {
    "link": "https://example.com/landing-page"
  }
}
</i18n>

<template>
  <div class="flex flex-col gap-8">
    <OwnInputContainer :label="t('title')">
      <ImageInput
        v-model="image"
        :label="t('labels.select')"
        :upload-label="t('labels.upload')"
        :crop-width="700"
      />
    </OwnInputContainer>
    <OwnInputContainer v-if="linkablePhotoEnabled" :label="t('labels.link')">
      <OwnInput v-model="link" :placeholder="t('placeholders.link')" />
    </OwnInputContainer>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { useI18n } from 'vue-i18n'
import { mapGetters } from 'vuex'

import { ImageInput } from '@/components/inputs/ImageInput'
import { OwnInput } from '@/ui/OwnInput'
import { OwnInputContainer } from '@/ui/OwnInputContainer'
import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

import { ImageCommands } from '../commands/ImageCommands'

export default {
  name: 'ImageEditor',
  components: { ImageInput, OwnInput, OwnInputContainer },
  props: {
    /** ID of the block */
    id: { type: String, required: true },
  },
  setup() {
    const { t } = useI18n()
    const { enabled: linkablePhotoEnabled } = useReactiveFeatureFlag(
      'hermes.emailBuilder.linkablePhoto'
    )

    return { linkablePhotoEnabled, t }
  },
  data() {
    return {
      image: null,
      link: '',
    }
  },
  computed: {
    ...mapGetters({
      blockById: 'emailBuilder/blockById',
    }),
    currentImage() {
      const { id } = this

      return this.blockById(id)?.data?.image
    },
    currentLink() {
      const { id } = this

      return this.blockById(id)?.data?.link ?? ''
    },
  },
  watch: {
    async image(image) {
      await ImageCommands.updateBlock({
        targetId: this.id,
        update: { data: { image } },
      })
    },
    link(link) {
      this.debouncedSaveLink(link)
    },
  },
  created() {
    this.debouncedSaveLink = debounce(
      async function (link) {
        await ImageCommands.updateBlock({
          targetId: this.id,
          update: { data: { link: link || null } },
        })
      }.bind(this),
      500
    )
  },
  mounted() {
    this.image = this.currentImage
    this.link = this.currentLink
  },
  beforeUnmount() {
    this.debouncedSaveLink.cancel()
  },
}
</script>
